<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad text-center">

                    <!-- suspended service status -->
                    <div class="sau-status-box">
                        <div class="sau-i-circle md danger">
                            <i class="md white" :class="icons[this.getServiceType()]"></i>
                        </div>
                        <h5 class="sau-para-m pt-2">Status: <span class="text-danger">Suspended</span></h5>
                        <p class="sau-font sm">Status Last Checked: {{ new Date() | moment("dddd, MMMM Do YYYY") }}</p>
                        <p class="sau-font sm">Functionality for this service has been restricted while suspended</p>
                        <!-- provide a payment link for each overdue invoice -->
                        <template v-if="overdue.length > 0">
                            <a v-for="invoice in overdue" :key="invoice" :href="getPaymentLink(invoice)" class="btn btn-danger">Pay Invoice #{{ invoice }}</a>
                        </template>
                        <a v-else href="#" class="btn btn-danger" @click.prevent="actionSupport">Contact support</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['service'],
    data() {
        return {
            overdue: {},
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            // Check overdue invoices
            this.getServiceInvoices().then(response => {
                this.checkOverdue(response.data.data);
                this.invoices = true;
            });
            // Lock down the menu for this service
            this.disableLinks();
        },
        checkOverdue(invoices) {
            _.forIn(invoices, function(val, key) {
                let diff = moment().diff(moment(val.duedate), 'days');
                if(diff > 0) {
                    // Overdue invoice
                    if(!this.overdue.includes(val.invoiceid)) {
                        this.overdue.push(val.invoiceid);
                    }
                }
            }.bind(this));
            if(this.overdue.length > 0) {
                this.status.overdue = true;
            }
        },
        disableLinks() {
            // set active class on all links where the href matches the current url
            let links = Array.from(document.querySelectorAll(`.sau-menu-aside ul li a`));
            links.forEach(function(link) {
                // Disable link - filter out summary and billing pages
                if(link.innerHTML != 'Summary' && link.innerHTML != 'Billing') {
                    link.classList.add('disable-link');
                    link.href = '#';
                }
             });
        }
    },
    computed: {
    }
}
</script>
<style>
.disable-link {
    color: currentColor;
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration: none;
}
</style>